export default __webpack_public_path__ + "static/media/solution-pac.a6e9e7ed.svg";